/**
 * API Service Configuration
 *
 * This file sets up the base Axios instance used throughout the application
 * for making HTTP requests to the backend API. The base URL is configured
 * from environment variables.
 *
 * Usage:
 * - Import this instance whenever you need to make direct API calls
 * - For most cases, you should use the API declarations in services/api-declaration.js
 * - This instance will be enhanced with interceptors in setupInterceptors.js
 */

import axios from "axios";

// Get the API base URL from environment variables
const baseURL = process.env.REACT_APP_BASE_URL;

// Create a configured Axios instance
const instance = axios.create({ baseURL });

export default instance;
